export const GetColor = (indication) => {
  switch (indication) {
    case "StrongBuy":
      return "#43a047";
    case "Buy":
      return "#81c784";
    case "OverBought":
      return "#1b5e20";
    case "Sell":
      return "#ef5350";
    case "StrongSell":
      return "#d32f2f";
    case "OverSold":
      return "#b71c1c";
    case "Neutral":
      return "#cfd8dc";
    default:
      return "#000000";
  }
};
